
import { defineComponent, ref, useContext, getCurrentInstance } from "@nuxtjs/composition-api";
import MemberCard from "~/components/general/memberCard.vue";
import core from "~/core";
export default defineComponent({
  components: { MemberCard },
  setup() {
    let redirect: any = null;
    try {
      const _ctx = useContext();
      redirect = (_ctx as any).redirect;
    } catch (e) {
      const inst: any = getCurrentInstance() && getCurrentInstance().proxy;
      redirect = inst ? inst.$router && inst.$router.push : null;
    }
    const goToMainPage = () => {
      open("https://bsi-sc.com", "_parent");
    };
    return {
      goToMainPage,
    };
  },
});
